(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page"]) return;
  try {
    
  class FaqNavigation extends HTMLElement {
    connectedCallback() {
      this.links = [...this.querySelectorAll('.faq-nav__link')];
      this.categories = [];
      this.isScrolling = false;

      this.links.forEach((link) => {
        const id = link.getAttribute('href').substring(1);
        const target = document.getElementById(id);
        if (target) this.categories.push({ element: target, link });
      });

      if (this.categories.length === 0) return;

      this.links.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const id = link.getAttribute('href').substring(1);
          const target = document.getElementById(id);
          if (!target) return;

          this.isScrolling = true;
          this.setActive(link);
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });

          // Re-enable observer tracking after scroll settles
          clearTimeout(this.scrollTimeout);
          this.scrollTimeout = setTimeout(() => {
            this.isScrolling = false;
          }, 800);
        });
      });

      this.observer = new IntersectionObserver(
        (entries) => {
          if (this.isScrolling) return;
          for (const entry of entries) {
            if (entry.isIntersecting) {
              const cat = this.categories.find((c) => c.element === entry.target);
              if (cat) this.setActive(cat.link);
            }
          }
        },
        { rootMargin: '-20% 0px -60% 0px' }
      );

      this.categories.forEach((cat) => this.observer.observe(cat.element));
    }

    setActive(activeLink) {
      this.links.forEach((link) => link.classList.remove('active'));
      activeLink.classList.add('active');

      // Scroll nav to keep active link visible
      const scrollContainer = this.querySelector('.faq-nav__scroll');
      if (scrollContainer) {
        const linkRect = activeLink.getBoundingClientRect();
        const containerRect = scrollContainer.getBoundingClientRect();
        if (linkRect.left < containerRect.left || linkRect.right > containerRect.right) {
          activeLink.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      clearTimeout(this.scrollTimeout);
    }
  }

  if (!customElements.get('faq-navigation')) {
    customElements.define('faq-navigation', FaqNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
